import { FluxStandardAction } from "../../../__utils/type";
import * as Actions from "../../../constants/actions";

export const uploadCancelChqeue = (data: any): FluxStandardAction => {
    return {
        type: Actions.FETCH_POST_CANCEL_UPLOAD_CHEQUE,
        payload: {
            data: data
        }
    }
};
export const uploadCancelChqeueSuccess = (response: any): FluxStandardAction => {
    return {
        type: Actions.FETCH_POST_CANCEL_UPLOAD_CHEQUE_SUCCESS,
        payload: {
            data: response
        }
    }
};

export const uploadCancelChqeueError = (error: any): FluxStandardAction => {
    return {
        type: Actions.FETCH_POST_CANCEL_UPLOAD_CHEQUE_FAILURE,
        payload: {
            data: error
        }
    }
};
export const searchIfsc = (ifsc: any): FluxStandardAction => {
    return {
        type: Actions.FETCH_GET_CHECK_IFSC,
        payload: {
            ifsc: ifsc
        }
    }
};
export const searchIfscSuccess = (response: any): FluxStandardAction => {
    return {
        type: Actions.FETCH_GET_CHECK_IFSC_SUCCESS,
        payload: {
            data: response
        }
    }
};

export const searchIfscError = (error: any): FluxStandardAction => {
    return {
        type: Actions.FETCH_GET_CHECK_IFSC_ERROR,
        payload: {
            data: error
        }
    }
};